/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useRef, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import makeRequest from "../../makeRequest";

/* ─── Injected styles ─────────────────────────────────────────────── */
const STYLE_ID = "contact-page-styles";
if (typeof document !== "undefined" && !document.getElementById(STYLE_ID)) {
  const s = document.createElement("style");
  s.id = STYLE_ID;
  s.textContent = `
    @keyframes cFadeUp {
      from { opacity: 0; transform: translateY(32px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes cFadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
    @keyframes cPulse {
      0%, 100% { transform: scale(1); }
      50%       { transform: scale(1.08); }
    }
    @keyframes cSlideLeft {
      from { opacity: 0; transform: translateX(-40px); }
      to   { opacity: 1; transform: translateX(0); }
    }
    @keyframes cSlideRight {
      from { opacity: 0; transform: translateX(40px); }
      to   { opacity: 1; transform: translateX(0); }
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    .ct-info-card {
      background: #fff;
      border-radius: 16px;
      padding: 36px 28px;
      box-shadow: 0 4px 28px rgba(27,116,187,0.09);
      border: 1px solid #e8f1fb;
      transition: transform .25s, box-shadow .25s;
      text-align: center;
      height: 100%;
    }
    .ct-info-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 16px 48px rgba(27,116,187,0.18);
    }
    .ct-info-card__icon {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: linear-gradient(135deg, #1b74bb 0%, #0d3b6e 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 20px;
      animation: cPulse 3s ease-in-out infinite;
    }
    .ct-info-card__label {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 2.5px;
      text-transform: uppercase;
      color: #1b74bb;
      margin-bottom: 10px;
    }
    .ct-info-card__title {
      font-size: 18px;
      font-weight: 800;
      color: #0f172a;
      margin: 0 0 8px;
    }
    .ct-info-card p, .ct-info-card a {
      font-size: 14px;
      color: #64748b;
      line-height: 1.8;
      text-decoration: none;
      display: block;
      transition: color .2s;
    }
    .ct-info-card a:hover { color: #1b74bb; }

    .ct-form-section {
      background: #f4f8fd;
      border-radius: 24px;
      padding: 52px 48px;
      box-shadow: 0 8px 48px rgba(27,116,187,0.07);
      border: 1px solid #dce8f5;
    }
    @media (max-width: 767px) { .ct-form-section { padding: 36px 20px; } }
    .ct-form-section h2 {
      font-size: clamp(22px, 3vw, 32px);
      font-weight: 800;
      color: #0f172a;
      margin: 0 0 6px;
    }
    .ct-form-section p.ct-sub {
      font-size: 14px;
      color: #64748b;
      margin: 0 0 36px;
    }
    .ct-input-group {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin-bottom: 20px;
    }
    .ct-input-group label {
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #475569;
    }
    .ct-input-group input,
    .ct-input-group textarea {
      border: 1.5px solid #d1dce9;
      border-radius: 10px;
      padding: 12px 16px;
      font-size: 14px;
      color: #0f172a;
      background: #fff;
      width: 100%;
      outline: none;
      transition: border-color .2s, box-shadow .2s;
      resize: vertical;
      font-family: inherit;
    }
    .ct-input-group input:focus,
    .ct-input-group textarea:focus {
      border-color: #1b74bb;
      box-shadow: 0 0 0 3px rgba(27,116,187,0.12);
    }
    .ct-input-group input.ct-error,
    .ct-input-group textarea.ct-error { border-color: #ef4444; }
    .ct-error-msg { font-size: 12px; color: #ef4444; margin-top: 2px; }

    .ct-submit-btn {
      background: linear-gradient(135deg, #1b74bb 0%, #0d3b6e 100%);
      color: #fff;
      border: none;
      border-radius: 10px;
      padding: 14px 40px;
      font-size: 15px;
      font-weight: 700;
      cursor: pointer;
      transition: transform .2s, box-shadow .2s, opacity .2s;
      display: inline-flex;
      align-items: center;
      gap: 10px;
    }
    .ct-submit-btn:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(27,116,187,0.35);
    }
    .ct-submit-btn:disabled { opacity: 0.65; cursor: not-allowed; }

    .ct-success-box {
      background: #f0fdf4;
      border: 1.5px solid #86efac;
      border-radius: 12px;
      padding: 20px 24px;
      display: flex;
      align-items: flex-start;
      gap: 14px;
      animation: cFadeIn .4s ease;
    }
    .ct-success-box p { margin: 0; font-size: 14px; color: #166534; font-weight: 500; }

    .ct-map-wrap {
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 8px 40px rgba(27,116,187,0.12);
      border: 2px solid #dce8f5;
      height: 440px;
    }
    .ct-map-wrap iframe { width: 100%; height: 100%; border: none; display: block; }

    .ct-divider {
      display: flex;
      justify-content: center;
      gap: 5px;
      margin: 14px auto 0;
    }
    .ct-divider div:nth-child(1) { width: 44px; height: 4px; border-radius: 2px; background: #1b74bb; }
    .ct-divider div:nth-child(2) { width: 12px; height: 4px; border-radius: 2px; background: #1b74bb80; }
    .ct-divider div:nth-child(3) { width: 5px;  height: 4px; border-radius: 2px; background: #1b74bb30; }
  `;
  document.head.appendChild(s);
}

/* ─── Contact Info Card ───────────────────────────────────────── */
function InfoCard({ icon, label, title, children, delay }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return (
    <div ref={ref} style={{ opacity: visible ? 1 : 0, animation: visible ? `cFadeUp 0.6s ${delay}s ease both` : "none" }}>
      <div className="ct-info-card">
        <div className="ct-info-card__icon">{icon}</div>
        <p className="ct-info-card__label">{label}</p>
        <h4 className="ct-info-card__title">{title}</h4>
        {children}
      </div>
    </div>
  );
}

/* ═══ Main Component ══════════════════════════════════════════════ */
const ContactMain = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", comments: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const [formVisible, setFormVisible] = useState(false);
  const formSectionRef = useRef(null);
  useEffect(() => {
    const el = formSectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setFormVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.05 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Name is required";
    if (!form.email.trim()) e.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Enter a valid email";
    if (!form.subject.trim()) e.subject = "Subject is required";
    if (!form.comments.trim()) e.comments = "Message is required";
    return e;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const v = validate();
    if (Object.keys(v).length > 0) {
      setErrors(v);
      return;
    }
    setSubmitting(true);
    try {
      await makeRequest({ route: "/website/contact-message/public", method: "post", data: form });
      setSuccess(true);
      setForm({ name: "", email: "", subject: "", comments: "" });
    } catch (err) {
      setErrors({ submit: err?.message || "Failed to send message. Please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main>
      <Breadcrumb title="Contact Us" subTitle="Contact Us" />

      {/* ── Hero strip ─────────────────────────────────────────── */}
      <section style={{ background: "linear-gradient(135deg, #0d3b6e 0%, #1b74bb 100%)", padding: "56px 0 48px" }}>
        <div className="container">
          <div style={{ textAlign: "center", animation: "cFadeIn .8s ease both" }}>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                background: "rgba(255,255,255,0.12)",
                borderRadius: 50,
                padding: "6px 20px",
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: 2,
                textTransform: "uppercase",
                color: "#fff",
                marginBottom: 16,
              }}
            >
              <i className="fa-solid fa-envelope" /> Get In Touch
            </span>
            <h1 style={{ fontSize: "clamp(28px,4vw,48px)", fontWeight: 900, color: "#fff", margin: "0 0 14px", lineHeight: 1.15 }}>
              We're Here to Help You
            </h1>
            <p style={{ fontSize: 16, color: "rgba(255,255,255,0.75)", maxWidth: 520, margin: "0 auto" }}>
              Reach out to Maroof International Hospital — our team is ready to assist you with appointments, inquiries, and support.
            </p>
          </div>
        </div>
      </section>

      {/* ── Info cards ─────────────────────────────────────────── */}
      <section style={{ background: "#f8fafc", padding: "64px 0 72px", marginTop: -1 }}>
        <div className="container">
          <div className="row g-4">
            <div className="col-xl-4 col-md-4 col-sm-6">
              <InfoCard
                label="Call Us"
                title="Phone Numbers"
                delay={0.1}
                icon={<i className="fa-solid fa-phone" style={{ color: "#fff", fontSize: 24 }} />}
              >
                <a href="tel:+925122229200">+92-51-2222920-50</a>
                <a href="tel:+921116449110">+92-51-111-644-911</a>
              </InfoCard>
            </div>
            <div className="col-xl-4 col-md-4 col-sm-6">
              <InfoCard
                label="Email Us"
                title="Email Address"
                delay={0.2}
                icon={<i className="fa-solid fa-envelope" style={{ color: "#fff", fontSize: 24 }} />}
              >
                <a href="mailto:info@maroof.com.pk">info@maroof.com.pk</a>
              </InfoCard>
            </div>
            <div className="col-xl-4 col-md-4 col-sm-12">
              <InfoCard
                label="Visit Us"
                title="Our Location"
                delay={0.3}
                icon={<i className="fa-solid fa-location-dot" style={{ color: "#fff", fontSize: 24 }} />}
              >
                <p>
                  Maroof International Hospital,
                  <br />
                  F-10 Markaz, Islamabad, Pakistan
                </p>
              </InfoCard>
            </div>
          </div>
        </div>
      </section>

      {/* ── Map ────────────────────────────────────────────────── */}
      <section style={{ background: "#fff", padding: "72px 0 72px" }}>
        <div className="container">
          <div style={{ textAlign: "center", marginBottom: 48 }}>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                background: "#edf5fb",
                border: "1.5px solid #bee0ef",
                borderRadius: 50,
                padding: "6px 20px",
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: 2,
                textTransform: "uppercase",
                color: "#1b74bb",
              }}
            >
              <i className="fa-solid fa-map-pin" /> Find Us
            </span>
            <h2 style={{ fontSize: "clamp(24px,3.5vw,38px)", fontWeight: 800, color: "#0f172a", margin: "14px 0 0" }}>Our Location</h2>
            <div className="ct-divider">
              <div />
              <div />
              <div />
            </div>
          </div>

          <div className="ct-map-wrap">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3320.5559876741!2d73.01359397559566!3d33.72316308074879!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfbe7ab8f8e70f%3A0x10867b08f28f765f!2sMaroof%20International%20Hospital!5e0!3m2!1sen!2s!4v1714900000000!5m2!1sen!2s"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Maroof International Hospital Location"
            />
          </div>
        </div>
      </section>

      {/* ── Contact Form ───────────────────────────────────────── */}
      <section style={{ background: "#f8fafc", padding: "0 0 80px" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10">
              <div
                ref={formSectionRef}
                className="ct-form-section"
                style={{ opacity: formVisible ? 1 : 0, animation: formVisible ? "cFadeUp 0.7s 0.1s ease both" : "none" }}
              >
                <div style={{ textAlign: "center", marginBottom: 36 }}>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 8,
                      background: "#edf5fb",
                      border: "1.5px solid #bee0ef",
                      borderRadius: 50,
                      padding: "6px 20px",
                      fontSize: 12,
                      fontWeight: 700,
                      letterSpacing: 2,
                      textTransform: "uppercase",
                      color: "#1b74bb",
                      marginBottom: 16,
                    }}
                  >
                    <i className="fa-solid fa-paper-plane" /> Message Us
                  </span>
                  <h2 style={{ fontSize: "clamp(22px,3vw,32px)", fontWeight: 800, color: "#0f172a", margin: "0 0 6px" }}>Leave Us a Message</h2>
                  <p className="ct-sub">Fill in the form below and we'll get back to you as soon as possible.</p>
                </div>

                {success ? (
                  <div className="ct-success-box">
                    <i className="fa-solid fa-circle-check" style={{ color: "#22c55e", fontSize: 22, flexShrink: 0, marginTop: 2 }} />
                    <div>
                      <p style={{ fontWeight: 700, marginBottom: 4 }}>Message sent successfully!</p>
                      <p>Thank you for contacting Maroof International Hospital. Our team will get back to you shortly.</p>
                      <button
                        onClick={() => setSuccess(false)}
                        style={{
                          marginTop: 12,
                          background: "none",
                          border: "none",
                          color: "#1b74bb",
                          fontWeight: 600,
                          cursor: "pointer",
                          padding: 0,
                        }}
                      >
                        Send another message
                      </button>
                    </div>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} noValidate>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="ct-input-group">
                          <label htmlFor="ct-name">Your Name</label>
                          <input
                            id="ct-name"
                            type="text"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            placeholder="e.g. Ahmed Khan"
                            className={errors.name ? "ct-error" : ""}
                          />
                          {errors.name && <span className="ct-error-msg">{errors.name}</span>}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="ct-input-group">
                          <label htmlFor="ct-email">Your Email</label>
                          <input
                            id="ct-email"
                            type="email"
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                            placeholder="e.g. ahmed@example.com"
                            className={errors.email ? "ct-error" : ""}
                          />
                          {errors.email && <span className="ct-error-msg">{errors.email}</span>}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="ct-input-group">
                          <label htmlFor="ct-subject">Subject</label>
                          <input
                            id="ct-subject"
                            type="text"
                            name="subject"
                            value={form.subject}
                            onChange={handleChange}
                            placeholder="e.g. Appointment Inquiry"
                            className={errors.subject ? "ct-error" : ""}
                          />
                          {errors.subject && <span className="ct-error-msg">{errors.subject}</span>}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="ct-input-group">
                          <label htmlFor="ct-comments">Message</label>
                          <textarea
                            id="ct-comments"
                            name="comments"
                            rows={5}
                            value={form.comments}
                            onChange={handleChange}
                            placeholder="Write your message here..."
                            className={errors.comments ? "ct-error" : ""}
                          />
                          {errors.comments && <span className="ct-error-msg">{errors.comments}</span>}
                        </div>
                      </div>
                    </div>

                    {errors.submit && (
                      <div
                        style={{ background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: 10, padding: "12px 16px", marginBottom: 20 }}
                      >
                        <p style={{ margin: 0, fontSize: 13, color: "#b91c1c" }}>{errors.submit}</p>
                      </div>
                    )}

                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <button type="submit" className="ct-submit-btn" disabled={submitting}>
                        {submitting ? (
                          <>
                            <span
                              style={{
                                width: 18,
                                height: 18,
                                border: "2px solid rgba(255,255,255,0.3)",
                                borderTopColor: "#fff",
                                borderRadius: "50%",
                                display: "inline-block",
                                animation: "spin 0.7s linear infinite",
                              }}
                            />
                            Sending…
                          </>
                        ) : (
                          <>
                            <i className="fa-solid fa-paper-plane" />
                            Send Message
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Emergency banner ───────────────────────────────────── */}
      <section style={{ background: "linear-gradient(135deg, #0d3b6e 0%, #1b74bb 100%)", padding: "48px 0" }}>
        <div className="container">
          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 24 }}>
            <div style={{ animation: "cSlideLeft .7s ease both" }}>
              <h3 style={{ color: "#fff", fontWeight: 800, fontSize: 24, margin: "0 0 6px" }}>
                <i className="fa-solid fa-triangle-exclamation" style={{ color: "#fbbf24", marginRight: 10 }} />
                Emergency? We're available 24/7
              </h3>
              <p style={{ color: "rgba(255,255,255,0.75)", margin: 0, fontSize: 14 }}>
                For medical emergencies, call our emergency line immediately.
              </p>
            </div>
            <a
              href="tel:+921116449110"
              style={{
                background: "#fff",
                color: "#0d3b6e",
                borderRadius: 10,
                padding: "14px 32px",
                fontWeight: 800,
                fontSize: 16,
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center",
                gap: 10,
                animation: "cSlideRight .7s ease both",
              }}
            >
              <i className="fa-solid fa-phone" />
              +92-51-111-644-911
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactMain;
